import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgxsModule } from '@ngxs/store';
import { AuthState } from './state/auth/auth.state';
import { SubscriptionState } from './state/subscription/subscription.state';

import {
  SocialLoginModule,
  FacebookLoginProvider,
  SocialAuthServiceConfig,
} from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { environment } from 'src/environments/environment';
import { LocaleConfigModule } from '../locale-config.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

@NgModule({
  imports: [
    NgxsModule.forFeature([AuthState, SubscriptionState]),
    SocialLoginModule,
    CommonModule,
    LocaleConfigModule,
    RecaptchaV3Module,
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookAuthKey),
          },
        ],
      } as SocialAuthServiceConfig,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaKey,
    },
  ],
  declarations: [],
  exports: [],
  entryComponents: [],
})
export class AuthModule {}
